<template>
  <e-dialog ref="dialogRef" transparent-content full-with-on-tablet>
    <template #activator>
      <profile-button short />
    </template>
    <template #title>
      <profile-button />
    </template>
    <default-layout-menu show-profile-menu @item-click="closeMenu" />
  </e-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { IDialog } from '@/core/types/components/components';
import EDialog from '@/core/components/modals/Dialog.vue';
import ProfileButton from '@/core/layouts/components/ProfileButton.vue';
import DefaultLayoutMenu from '@/core/layouts/components/default/DefaultLayoutMenu.vue';

const dialogRef = ref<IDialog>();

const closeMenu = () => {
  dialogRef.value?.close();
};
</script>

<style scoped lang="scss"></style>
